(function ($, root, undefined) {
	$(function () {
		//define url
		var url_string = window.location.href,
			url = new URL(url_string);

		const body = $("body");

		//initialize iCheck
		$("input[type=checkbox]").iCheck({ focusClass: "focus" });

		$(".show-menu").on("click", function (e) {
			e.preventDefault();
			$(".header nav").toggle();
			$("html").toggleClass("fixed");
			$(this).toggleClass("close");
		});

		$(".trigger-open-menu").on("click", function (e) {
			$(".header").addClass("menu--opened").removeClass("menu--closed");
			body.addClass("no-scroll");
		});

		$(".trigger-close-menu").on("click", function (e) {
			$(".header").addClass("menu--closed").removeClass("menu--opened");
			body.removeClass("no-scroll");
		});

		//Mobile Equipements open/close
		$(".car-equip-div.show-mobile")
			.find(".car-equip-title")
			.on("touchstart mousedown", function (e) {
				e.preventDefault();
				$(this).parent().toggleClass("show-more");
				$(this).parent().find(".car-equip").slideToggle();
			});

		// Home filters based on input checkbox
		var filters = $(".filters"),
			results = $(".results-cards"),
			checkedVal = [];

		filters.on("ifClicked", 'input[type="checkbox"]', function (e) {
			var vals = $(this).val().split(",");
			var i = 0;
			if ($(this).parent().hasClass("checked")) {
				for (i = 0; i < vals.length; i++) {
					var index = checkedVal.indexOf(vals[i]);
					checkedVal.splice(index, 1);
				}
			} else {
				for (i = 0; i < vals.length; i++) {
					checkedVal.push(vals[i]);
				}
			}
			if (!checkedVal.length) {
				results.find(".card").css("display", "inline-block");
			} else {
				results.find(".card:not(.card-banner)").css("display", "none");
				checkedVal.forEach(function (value) {
						results
							.find(".card.filter-" + value)
							.css("display", "inline-block");
				});
			}

			// track click on filters
			if (typeof window.trackFilters === "function") {
				var trackedVal = checkedVal;
				trackFilters(trackedVal);
			}
		});

		//Range filters based on URL
		var range = url.searchParams.get("range"),
			ranges = [];
		filters.find("input").each(function () {
			ranges.push($(this).val());
		});
		if (range !== null) {
			if (range == "combustion") {
				filters
					.find('input[type="checkbox"][value="combustion"')
					.iCheck("check");
				results.find(".card").css("display", "none");
				results.find(".card.filter-combustion").css("display", "inline-block");
				results.find(".card.card-banner").css("display", "inline-block");
			} else if (range == "electric") {
				filters.find('input[type="checkbox"][value="electric"').iCheck("check");
				results.find(".card").css("display", "none");
				results.find(".card.filter-electric").css("display", "inline-block");
				results.find(".card.card-banner").css("display", "inline-block");
			} else if (range == "ze" || range == "e-tech") {
				if (range == "ze" || range == "e-tech") {
					range = "e-tech";
				}
				filters.find('input[type="checkbox"]').iCheck("check");
				filters
					.find('input[type="checkbox"][value="combustion"]')
					.iCheck("uncheck");
				results.find(".card").css("display", "none");
				results.find(".card.filter-electric").css("display", "inline-block");
				results.find(".card.filter-hybrid").css("display", "inline-block");
				results
					.find(".card.filter-plugin-hybrid")
					.css("display", "inline-block");
				results.find(".card.card-banner").css("display", "inline-block");
			} else if (range == "hybrid") {
				filters.find('input[type="checkbox"][value="hybrid,plugin-hybrid"]').iCheck("check");
				results.find(".card").css("display", "none");
				results.find(".card.filter-hybrid").css("display", "inline-block");
				results
					.find(".card.filter-plugin-hybrid")
					.css("display", "inline-block");
				results.find(".card.card-banner").css("display", "inline-block");
			}
		}

		// if filters are present
		if (filters.length) {
			var checkboxes = filters.find(".icheckbox");
			// check if each checkbox is checked and add it to the checkedVal array
			checkboxes.each(function () {
				if ($(this).hasClass("checked")) {
					var vals = $(this).find("input").val().split(",");
					for (var i = 0; i < vals.length; i++) {
						checkedVal.push(vals[i]);
					}
				}
			});
			// if checkedVal > 1, so some filters are checked
			if (checkedVal.length > 1) {
				results.find(".card:not(.card-banner)").css("display", "none");
				checkedVal.forEach(function (value) {
					results
						.find(".card.filter-" + value)
						.css("display", "inline-block");
				});
			}
		}

		//scroll to anchor
		var link = $(".anchor-link");
		link.on("click", function (e) {
			e.preventDefault();
			var anchor = $(this).attr("href");
			$("html, body").animate(
				{
					scrollTop: $(anchor).offset().top - 20,
				},
				400
			);
		});

		//Legal popin
		var legalPopup = $(".legal-popup");
		legalPopup.on("mousedown touchstart", ".close, .close-cta", function (e) {
			e.preventDefault();
			legalPopup.slideUp().fadeOut();
			body.removeClass("no-scroll");
		});

		if (legalPopup.is(":visible") && window.innerWidth <= 600) {
			body.addClass("no-scroll");
		}

		var openModal = function () {
			const scrollY = $(window).scrollTop();
			body.css({
				position: "fixed",
				top: -scrollY,
			});
			$(".overlay").fadeIn();
			body.addClass("no-scroll");
		};

		$(".modal-link").on("mousedown touchstart", function (e) {
			e.preventDefault();

			openModal();
			$(this).parents(".car-offer").find(".modal-box").fadeIn();
		});

		$(".info-trigger, .ei-trigger").on("click", function (e) {
			e.preventDefault();
			var modal = $(this).data("trigger");

			openModal();
			$("." + modal + ".modal-box").fadeIn();
		});

		$(".overlay, .modal-box .close").on("touchstart mousedown", function (e) {
			e.preventDefault();
			$(".overlay, .modal-box").fadeOut();
			const scrollY = body.css("top");
			body.css({
				position: "",
				top: "",
			});
			body.removeClass("no-scroll");
			window.scrollTo(0, parseInt(scrollY || "0") * -1);
		});

	});
})(jQuery, this);
